import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as S from './clickToCallEnergy.style';
import { callMeSchema } from './clickToCallEnergy.validation';
import { ICallMeBackSchema, IClickToCall } from './clickToCallEnergy.models';
import { ClickToCallCardSubmitted } from '../clickToCallEnergyCardSubmitted/clickToCallEnergyCardSubmitted';
import { ClickToCallCardToSubmit } from '../clickToCallEnergyToSubmit/clickToCallEnergyCardToSubmit';

const ClickToCall: React.FC<IClickToCall> = ({
  onSubmit,
  isSuccess,
  isLoading,
  clickToCallData,
  defaultNumber,
  entryPoint,
  taggingOpts,
  pageProduct,
}) => {
  const form = useForm<ICallMeBackSchema>({
    resolver: yupResolver(callMeSchema()),
    defaultValues: {
      phoneNumber: defaultNumber || '',
    },
    mode: 'all',
  });

  if (isSuccess) {
    return (
      <S.ClickToCallCardFlow>
        <ClickToCallCardSubmitted
          entryPoint={entryPoint}
          taggingOpts={taggingOpts}
          pageProduct={pageProduct}
          clickToCallData={clickToCallData}
          phoneNumber={form?.getValues()?.phoneNumber || defaultNumber || ''}
        />
      </S.ClickToCallCardFlow>
    );
  }

  return (
    <S.ClickToCallCardFlow>
      <ClickToCallCardToSubmit
        clickToCallData={clickToCallData}
        form={form}
        handleSubmit={() => onSubmit?.(form.getValues()?.phoneNumber)}
        isLoading={isLoading}
      />
    </S.ClickToCallCardFlow>
  );
};

export default ClickToCall;
